import React from "react";

interface TagBadgeProps {
  tag: string;
  type?: string;
}

// You can expand this mapping as needed
const tagColorMap: Record<string, string> = {
  secondhand: "bg-blue-100 text-blue-800",
  custom: "bg-orange-100 text-orange-800",
  flea: "bg-purple-100 text-purple-800",
};

const TagBadge: React.FC<TagBadgeProps> = ({ tag, type }) => {
  // Use type if provided, else fallback to tag name
  const colorClass = type && tagColorMap[type] ? tagColorMap[type] : tagColorMap[tag.toLowerCase()] || "bg-gray-100 text-gray-700";
  return (
    <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${colorClass}`}>
      {tag}
    </span>
  );
};

export default TagBadge;
